import React from 'react';
import CategoryProduct from './CategoryProduct';
import './Section.css';

const Section = () => {
  return (
    <div className="container sticky">
      <CategoryProduct />
    </div>
  );
};

export default Section;
